import * as React from 'react';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import styled, { css } from 'styled-components';

type DropdownMenuItemProps = React.ComponentPropsWithoutRef<typeof DropdownMenuPrimitive.Item> & {
  inset?: boolean;
  variant?: 'default' | 'subtle';
};

const subtleStyles = css`
  padding: 6px 16px;
  color: ${({ theme }) => theme.tones.neutral[10]};
  ${({ theme }) => theme.typography.body4};
  display: flex;
  align-items: center;

  &:hover,
  &[data-highlighted] {
    background-color: ${({ theme }) => theme.colors.states.hover1};
  }
`;

const RootStyled = styled(DropdownMenuPrimitive.Item)<{ $variant: NonNullable<DropdownMenuItemProps['variant']> }>`
  padding: 8px 16px;
  color: ${({ theme }) => theme.colors.neutral.onBackground};
  ${({ theme }) => theme.typography.body3};
  outline: none;
  cursor: pointer;

  &:hover,
  &[data-highlighted] {
    background-color: ${({ theme }) => theme.colors.neutral.backgroundVariant};
  }

  &[data-disabled] {
    cursor: default;
    opacity: 0.5;
  }

  ${({ $variant }) => $variant === 'subtle' && subtleStyles}
`;

export const DropdownMenuItem = ({
  className,
  inset,
  variant = 'default',
  ...props
}: DropdownMenuItemProps): React.JSX.Element => {
  return (
    <RootStyled
      data-slot="dropdown-menu-item"
      data-inset={inset}
      data-variant={variant}
      $variant={variant}
      className={className}
      {...props}
    />
  );
};
